import { Paths } from "#/utils/Paths"
import { useTelemedicineAccess } from "@internal/telemedicine"
import { useFlags } from "launchdarkly-react-client-sdk"
import React from "react"
import { Redirect } from "react-router-dom"

// Program-agnostic entry for a generic "Book appointment" CTA: asks the backend which programs the
// member has and dispatches — none → home, single → that flow, multiple → the chooser. Program-
// specific entry points deep-link to the flow with `?program=` and skip this.
export function TelemedicineResolverPage(): JSX.Element | null {
  const { telemedicineBookingFlow } = useFlags()
  const { data: access, isLoading } = useTelemedicineAccess()

  if (!telemedicineBookingFlow) {
    return <Redirect to={Paths.HOME} />
  }

  if (isLoading || !access) {
    return null
  }

  const { entry } = access

  if (entry.status === "none") {
    return <Redirect to={Paths.HOME} />
  }

  if (entry.status === "single_qualified" || entry.status === "single_unqualified") {
    return <Redirect to={`${Paths.TELEMEDICINE_BOOKING}?program=${entry.program}`} />
  }

  // multiple
  return <Redirect to={Paths.PROVIDER_FINDER} />
}
